import React from "react";
import Slider from "react-slick";

function LogoSlider() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const logos = [
    "/assets/nav/newlogo2.png",
    // "/assets/nav/newlogo3.png",
    "/assets/nav/newlogo4.png",
    "/assets/nav/newlogo5.png",
    "/assets/nav/cembre.png",
    "/assets/nav/newlogo6.png",
    "/assets/nav/item5.png",
    // "/assets/nav/item9.png",
    "/assets/nav/newlogo1.png",
    "/assets/nav/new (1).png",
    "/assets/nav/l.png",

    "/assets/nav/new-logo (1).svg",
    // "/assets/nav/new-logo (1).png",
    // "/assets/nav/new-logo (2).png",
    "/assets/nav/yk2.png",
    "/assets/nav/end.png",
    "/assets/nav/l1.png",


    
  ];

  return (
    <div className="py-0">
      <Slider {...settings}>
        {logos.map((src, i) => (
          <div key={i} className="px-4">
            <div className="flex justify-center items-center">
              <div className="flex justify-center items-center bg-transparent w-[150px] h-[80px]">
                <img
                  src={src}
                  alt={`logo-${i}`}
                  className="max-h-[80px] w-auto object-contain mx-auto"
                />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default LogoSlider;
